import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { FaHome } from "react-icons/fa";
import { cn } from "../utils/utils";

interface LogoButtonProps {
  className?: string;
  [key: string]: any;
}

export function LogoButton({ className, ...rest }: LogoButtonProps) {
  const [isClicked, setIsClicked] = useState(false);

  // Reset the button state after a delay
  useEffect(() => {
    if (isClicked) {
      const timeoutId = setTimeout(() => {
        setIsClicked(false);
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [isClicked]);

  const variants = {
    initial: { scale: 1 },
    clicked: { scale: 0.92 }
  };

  return (
    <motion.button
      className={cn("bg-logo-grad group relative h-16 w-16 rounded-full", className)}
      transition={{ type: "spring" }}
      animate={isClicked ? "clicked" : "initial"}
      variants={variants}
      onMouseDown={() => setIsClicked(true)}
      {...rest}
    >
      <FaHome className="text-tx-primary absolute bottom-0 left-0 right-0 top-0 z-10 m-auto rotate-[140deg] opacity-0 transition-all duration-300 group-hover:rotate-[360deg] group-hover:opacity-100 sm:text-xl md:text-4xl" />
    </motion.button>
  );
}
